import React from 'react'
import './about.css'
import PFP from '../../assets/PFP.jpg'
import {MdOutlineSecurity} from 'react-icons/md'
import {BsPatchCheck} from 'react-icons/bs'
import {FiServer} from 'react-icons/fi'

const About = () => {
  return (
    <section id='about'>
      <h5>Get to know</h5>
      <h2>About Me</h2>

      <div className='container about_container'>
        <div className='about_me'>
          <div className='about_me-image'>
            <img src={PFP} alt='Darius Williams'/>
          </div>
        </div>
        
        <div className='about_content'>
          <div className='about_cards'>
            <article className='about_card'>
              <MdOutlineSecurity className='about_icon'/>
              <h5>Web Security Analyst</h5>
              <small>SiteLock (Sectigo), full time since Aug 2026</small>
            </article>
            
            <article className='about_card'>
              <BsPatchCheck className='about_icon'/>
              <h5>CompTIA Security+</h5>
              <small>Certified 2026 — core security operations foundation</small>
            </article>
            
            <article className='about_card'>
              <FiServer className='about_icon'/>
              <h5>Hands-on Homelab</h5>
              <small>Linux, Pi-hole, file monitoring, self-hosted services</small>
            </article>
          </div>

          <p>
            I work in web security at SiteLock, a Sectigo company, cleaning malware from customer
            servers and turning what I find into regex and internal tools so the team can remediate
            faster. I am CompTIA Security+ certified and building toward security operations roles
            where investigation, containment, and automation matter. Outside of work I run a Linux
            homelab with DNS filtering, file monitoring, Plex, and game servers — the same habit of
            watching hosts and keeping systems clean that I use on the job.
          </p>

          <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About
